<header class="header">

        <div class="logo in-blk">
            <img src="assets/imgs/target_logo.png" alt="logo target" height="40px" width="40px">
        </div>
        <img src="assets/imgs/rotaplan.ico"
         alt="logo rota plan"
         height="40px"
         width="40px"
         >
        <h1> Target Rota Plan 
                <span>| Gerenciador de Ocorrências</span>
        </h1>
        <div id="header-config" class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" style="color: #fff;" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        title="Configurações">
                        <i class='fa fa-cog' style="color: #fff;"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="header-config">
                        <a class="dropdown-item" href="#" data-toggle="modal" data-target="#popup-config"><i class="fa fa-cogs submenu-icon"></i> Configurações</a>
                </div>
        </div>

</header>
